import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { PlanBean } from 'src/app/_beans/PlanBean';
import { NivelSuperiorDTO } from 'src/app/_dtos/nivelSuperiorDTO';
import { ConstantesService } from './constantes.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FLOAT } from 'html2canvas/dist/types/css/property-descriptors/float';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  //ServerURL: string = 'http://localhost:8085/pnloti-be/';
  //ServerURL: string = 'http://54.188.75.126:8080/pnloti-be/';
  // ServerURL: string = 'http://192.25.0.186:8080/pnloti-be/';
  //ServerURL: string = 'http://localhost:8080/pnloti-be/';
  ServerURL: string = '/pnloti-be';
  sessionKey: string = '';
  userSession: any;
  planSession: PlanBean;
  menuItems: any[] = [];
  sharedData: any = {};
  messageInfo: Subject<string> = new Subject();
  messageWarn: Subject<string> = new Subject();
  sendObjectList: Subject<any> = new Subject();
  onMenuItemClick: Subject<any> = new Subject();
  sendObject: Subject<any> = new Subject();
  mensajeDelObjPadre: Subject<any> = new Subject();
  nombreNivelPadre: string = "";
  abrirSidebarObjetivos: boolean = false;
  menuItemSeleccionado: any = {};
  updateObjetivo: Subject<any> = new Subject();
  updateDashbard: Subject<any> = new Subject();
  cantidadAlertas: number = 0;
  updateSidebarObjetivos: Subject<any> = new Subject();
  limiteRojo:number;
  limiteAmbar:number;
  mobileSize:boolean=false;
  public showButton: boolean=false;
  public showButton2: boolean=true;
  public tipoAcceso = TipoAcceso;
  private opcion: any;
  public nivelesSuperioresList: NivelSuperiorDTO[] = [];
  public planSeleccionadoFinalizado: boolean = false;

  public detalleInformacionDefault = {
    avance: { codigo: -1, nombre: '% Avance' },
    responsable: { codigo: -2, nombre: 'Responsable' },
  }

  public variablesDefault = {
    capacitacion: { codigo: -2, nombre: 'Tipo de capacitación' },
    campana: { codigo: -3, nombre: 'Campaña' }
  }


  constructor(private constantes: ConstantesService,
    private snackbar: MatSnackBar,) {
  }

  public validarAccesoOpcion(opcion: string, accion: string, esAvance?: boolean, idUsuario?: number): boolean {
    let result: boolean = false;

    if (opcion == 'AGREGAR_REGISTRO' && (accion == this.tipoAcceso.Crear || accion == this.tipoAcceso.Editar) && this.userSession && this.userSession.perfil == this.constantes.TIPO_USUARIO_OPERADOR) {
      if (esAvance) {
        if (accion == this.tipoAcceso.Crear || (accion == this.tipoAcceso.Editar && idUsuario == this.userSession.usuario.id))
          return true;
        else
          return false;
      } else {
        return false;
      }
    }
    let opciones;
    if(!(this.userSession && this.userSession.id)){
      opciones=this.userSession.opciones;
     }else{
      opciones = JSON.parse(this.userSession.opciones);
     }
      this.buscarOpcion(opciones, opcion);
      if (this.opcion && this.opcion.permissions && this.opcion.permissions.includes(accion)) {
        result = true;
      }

    return result;
  }

  private buscarOpcion(opciones: any[], code) {
    let opcion = opciones.find(opc => opc.code == code);
    if (opcion) {
      this.opcion = opcion;
    } else {
      opciones.forEach(opc => {
        if (opc.items)
          this.buscarOpcion(opc.items, code);
      });
    }
  }

  public validateEmailFormat(email: string): boolean {
    let regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(email);
  }

  public addTimeOffSet(dt: Date): Date {
    let offsetTime;
    if (dt instanceof Date) {
      offsetTime = new Date(dt.getTime() + dt.getTimezoneOffset() * 60 * 1000);
    } else {
      let d = new Date(dt);
      offsetTime = new Date(d.getTime() + d.getTimezoneOffset() * 60 * 1000);
    }
    return offsetTime;
  }

  public showMessageWarn(message: string) {
    this.messageWarn.subscribe(msg => {
      this.snackbar.open(msg, '', {
        duration: 4000,
        panelClass: ['mat-toolbar', 'mat-warn']
      })
    });
    this.messageWarn.next(message);
  }

  public showMessageInfo(message: string) {
    this.messageInfo.subscribe(msg => {
      this.snackbar.open(msg, '', {
        duration: 4000,
        panelClass: ['mat-toolbar', 'mat-primary']
      })
    });
    this.messageInfo.next(message);
  }

  public getDescriptionByCode(code: string, listCatalogDetail: Array<any>): string {
    let found:any;
    found = listCatalogDetail.find(catalogDetail => catalogDetail.codigo == code);
    if(found){
      return  found.descripcion;
    }else{
      return  code;
    }
  }

  public destroySubjects(): void {
    this.onMenuItemClick.unsubscribe();
    this.messageInfo.unsubscribe();
    this.messageWarn.unsubscribe();
    this.sendObjectList.unsubscribe();
    this.sendObject.unsubscribe();
    this.mensajeDelObjPadre.unsubscribe();
    this.updateObjetivo.unsubscribe();
    this.updateDashbard.unsubscribe();
    this.updateSidebarObjetivos.unsubscribe();
    this.onMenuItemClick = new Subject();
    this.messageInfo = new Subject();
    this.messageWarn = new Subject();
    this.sendObjectList = new Subject();
    this.sendObject = new Subject();
    this.mensajeDelObjPadre = new Subject();
    this.updateObjetivo = new Subject();
    this.updateDashbard = new Subject();
    this.updateSidebarObjetivos = new Subject();
  }

  public chartOptions ( YAxis : number = 0 , isVertical = true ) {
    return {
      hover: {
        animationDuration: 0, // Desactiva la animación de hover
        mode: null, // Evita cualquier cambio visual en hover
      },
      tooltips: {
        enabled: true, // Desactiva los tooltips (opcional)
      },
     animation: {
        onComplete: (animation) => {
          const ctx = animation.chart.ctx; // Contexto del gráfico
          const chart = animation.chart; // Instancia del gráfico

          // Recorre cada barra del gráfico
          chart.data.datasets.forEach((dataset, i) => {
            const meta = chart.getDatasetMeta(i);
            meta.data.forEach((bar, index) => {
              let data = dataset.data[index]; // Valor de la barra
              const x = bar._model.x; // Posición X de la barra
              const y = bar._model.y; // Posición Y de la barra
              const base = bar._model.base


              // Configura el estilo del texto
              ctx.fillStyle = '#000'; // Color del texto
              ctx.font = '12px Arial'; // Fuente del texto
              ctx.textAlign = 'center'; // Alineación horizontal
              ctx.textBaseline = 'bottom'; // Alineación vertical

              // Dibuja el valor dentro de la barra
              if ( data != null && parseFloat(data) == 0 )  {
                data = ""
              }
              if ( isVertical) {
                ctx.fillText(data, x, YAxis != 0 ?  y + YAxis  : (y + base)/2); // Ajusta la posición del texto
              }else{
                ctx.fillText(data, (x  + base)/2 , y );
              }
            });
          });
        }
      }
    }
  }
}

export enum TipoAcceso {
  Crear = "CREAR",
  Editar = "EDITAR",
  Eliminar = "ELIMINAR",
  Ver = "VER"
}



